/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "CreditLineStatement": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "periodStartAt": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "periodEndAt": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "previousBalanceMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "purchasesMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "carriedBalanceMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "feeMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 9,
                    "rule": "optional"
                  },
                  "newBalanceMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 10,
                    "rule": "optional"
                  },
                  "minimumDueMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 11,
                    "rule": "optional"
                  },
                  "pastDueMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 12,
                    "rule": "optional"
                  },
                  "dueDate": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.corporate_card.resources.CreditLineStatement.Status",
                    "id": 14,
                    "rule": "optional"
                  },
                  "paymentsAndCreditsMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 15,
                    "rule": "optional"
                  },
                  "adjustmentsMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 16,
                    "rule": "optional"
                  },
                  "paymentsMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 17,
                    "rule": "optional"
                  },
                  "creditsMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 18,
                    "rule": "optional"
                  },
                  "paymentReversalsMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 19,
                    "rule": "optional"
                  },
                  "creditReversalsMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 20,
                    "rule": "optional"
                  },
                  "refundsMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 21,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "S_DO_NOT_USE": 0,
                      "DRAFTED": 1,
                      "PUBLISHED": 2,
                      "CANCELED": 3,
                      "IN_REVIEW": 4
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineStatement && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineStatement?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A credit line statement
 * --
 *
 * SOURCE CreditLineStatement @ squareup/corporate_card/resources/credit_line_statement.proto at 10:1
 */
export const CreditLineStatement = $root.lookupType('squareup.corporate_card.resources.CreditLineStatement');
fixType(CreditLineStatement);
Builder.createAndAttachToType(CreditLineStatement);
/**
 * --
 * @desc status of CreditLineStatement
 * --
 *
 * SOURCE Status @ squareup/corporate_card/resources/credit_line_statement.proto at 14:3
 */
CreditLineStatement.Status = $root.lookupEnum('squareup.corporate_card.resources.CreditLineStatement.Status').values;